(function () {
  'use strict';

  /* -------------------------------------------------------------
     AVENIX LANGUAGE SYSTEM
     - Uses country/browser detection on first visit.
     - Uses Google Translate for the complete visible storefront,
       including product titles/descriptions and Shopify-generated UI.
     - Never changes currency/payment settings.
  -------------------------------------------------------------- */
  var LANGUAGES = [
    {code:'en', flag:'🇺🇸', country:'US', native:'English'},
    {code:'en-GB', flag:'🇬🇧', country:'GB', native:'English (UK)'},
    {code:'pt-BR', flag:'🇧🇷', country:'BR', native:'Português (Brasil)'},
    {code:'pt-PT', flag:'🇵🇹', country:'PT', native:'Português (Portugal)'},
    {code:'es', flag:'🇪🇸', country:'ES', native:'Español'},
    {code:'es-MX', flag:'🇲🇽', country:'MX', native:'Español (México)'},
    {code:'fr', flag:'🇫🇷', country:'FR', native:'Français'},
    {code:'de', flag:'🇩🇪', country:'DE', native:'Deutsch'},
    {code:'it', flag:'🇮🇹', country:'IT', native:'Italiano'},
    {code:'nl', flag:'🇳🇱', country:'NL', native:'Nederlands'},
    {code:'pl', flag:'🇵🇱', country:'PL', native:'Polski'},
    {code:'uk', flag:'🇺🇦', country:'UA', native:'Українська'},
    {code:'ru', flag:'🇷🇺', country:'RU', native:'Русский'},
    {code:'cs', flag:'🇨🇿', country:'CZ', native:'Čeština'},
    {code:'sk', flag:'🇸🇰', country:'SK', native:'Slovenčina'},
    {code:'hu', flag:'🇭🇺', country:'HU', native:'Magyar'},
    {code:'ro', flag:'🇷🇴', country:'RO', native:'Română'},
    {code:'bg', flag:'🇧🇬', country:'BG', native:'Български'},
    {code:'el', flag:'🇬🇷', country:'GR', native:'Ελληνικά'},
    {code:'sv', flag:'🇸🇪', country:'SE', native:'Svenska'},
    {code:'no', flag:'🇳🇴', country:'NO', native:'Norsk'},
    {code:'da', flag:'🇩🇰', country:'DK', native:'Dansk'},
    {code:'fi', flag:'🇫🇮', country:'FI', native:'Suomi'},
    {code:'tr', flag:'🇹🇷', country:'TR', native:'Türkçe'},
    {code:'he', flag:'🇮🇱', country:'IL', native:'עברית'},
    {code:'ar', flag:'🇸🇦', country:'SA', native:'العربية'},
    {code:'ar-AE', flag:'🇦🇪', country:'AE', native:'العربية (الإمارات)'},
    {code:'fa', flag:'🇮🇷', country:'IR', native:'فارسی'},
    {code:'hi', flag:'🇮🇳', country:'IN', native:'हिन्दी'},
    {code:'bn', flag:'🇧🇩', country:'BD', native:'বাংলা'},
    {code:'ur', flag:'🇵🇰', country:'PK', native:'اردو'},
    {code:'id', flag:'🇮🇩', country:'ID', native:'Bahasa Indonesia'},
    {code:'ms', flag:'🇲🇾', country:'MY', native:'Bahasa Melayu'},
    {code:'vi', flag:'🇻🇳', country:'VN', native:'Tiếng Việt'},
    {code:'th', flag:'🇹🇭', country:'TH', native:'ไทย'},
    {code:'zh-CN', flag:'🇨🇳', country:'CN', native:'简体中文'},
    {code:'zh-TW', flag:'🇹🇼', country:'TW', native:'繁體中文'},
    {code:'ja', flag:'🇯🇵', country:'JP', native:'日本語'},
    {code:'ko', flag:'🇰🇷', country:'KR', native:'한국어'},
    {code:'en-CA', flag:'🇨🇦', country:'CA', native:'English (Canada)'},
    {code:'en-AU', flag:'🇦🇺', country:'AU', native:'English (Australia)'}
  ];

  var COUNTRY_MAP = {};
  LANGUAGES.forEach(function (l) { COUNTRY_MAP[l.country] = l.code; });
  Object.assign(COUNTRY_MAP, {
    NZ:'en', IE:'en', ZA:'en', SG:'en', AT:'de', CH:'de', BE:'nl', LU:'fr',
    MA:'ar', EG:'ar', QA:'ar-AE', KW:'ar-AE', BH:'ar-AE', OM:'ar-AE', JO:'ar',
    KH:'th', PH:'en', MY:'ms', BN:'ms'
  });

  function findLanguage(code) {
    if (!code) return null;
    var value = String(code).toLowerCase();
    return LANGUAGES.find(function (l) { return l.code.toLowerCase() === value; }) ||
      LANGUAGES.find(function (l) { return l.code.toLowerCase().split('-')[0] === value.split('-')[0]; });
  }

  function detectLanguage(header) {
    var saved = localStorage.getItem('avenix-language');
    if (saved) return findLanguage(saved) || findLanguage('en');
    return findLanguage('en');
  }

  function targetCode(lang) {
    /* Google Translate uses the base language for most regional variants. */
    if (lang.code === 'pt-BR' || lang.code === 'pt-PT') return 'pt';
    if (lang.code === 'zh-CN') return 'zh-CN';
    if (lang.code === 'zh-TW') return 'zh-TW';
    if (lang.code.indexOf('ar') === 0) return 'ar';
    if (lang.code.indexOf('en') === 0) return 'en';
    if (lang.code.indexOf('es') === 0) return 'es';
    return lang.code.split('-')[0];
  }

  function getGoogleTarget() {
    var match = document.cookie.match(/(?:^|; )googtrans=([^;]+)/);
    if (!match) return '';
    try {
      var value = decodeURIComponent(match[1]);
      return value.split('/').pop() || '';
    } catch (e) { return ''; }
  }

  function setGoogleLanguage(lang) {
    var target = targetCode(lang);
    var current = getGoogleTarget();
    localStorage.setItem('avenix-language', lang.code);

    if (target === 'en') {
      document.cookie = 'googtrans=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      document.cookie = 'googtrans=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=' + location.hostname;
    } else {
      var cookieValue = '/en/' + target;
      document.cookie = 'googtrans=' + encodeURIComponent(cookieValue) + '; path=/';
      document.cookie = 'googtrans=' + encodeURIComponent(cookieValue) + '; path=/; domain=' + location.hostname;
    }

    if (current !== target || (target === 'en' && current)) {
      location.reload();
      return;
    }
    updateLanguageUI(lang);
  }

  function updateLanguageUI(lang) {
    var flag = document.querySelector('[data-language-flag]');
    var code = document.querySelector('[data-language-code]');
    var trigger = document.querySelector('[data-language-picker] .language-trigger');
    if (flag) flag.textContent = lang.flag;
    if (code) code.textContent = lang.code.split('-')[0].toUpperCase();
    if (trigger) trigger.setAttribute('aria-label', 'Change language');
    document.querySelectorAll('.language-option').forEach(function (item) {
      var active = item.getAttribute('data-lang-code') === lang.code;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    document.documentElement.dir = lang.code.indexOf('ar') === 0 || lang.code === 'he' || lang.code === 'fa' || lang.code === 'ur' ? 'rtl' : 'ltr';
  }

  function buildLanguageMenu(current) {
    var menu = document.querySelector('[data-language-menu]');
    if (!menu) return;
    menu.innerHTML = LANGUAGES.map(function (lang) {
      return '<button type="button" class="language-option" role="option" data-lang-code="' + lang.code + '" aria-selected="false">' +
        '<span class="option-flag" aria-hidden="true">' + lang.flag + '</span>' +
        '<span class="option-name">' + lang.native + '</span>' +
        '<span class="option-code">' + lang.code.split('-')[0].toUpperCase() + '</span>' +
      '</button>';
    }).join('');

    menu.querySelectorAll('.language-option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var selected = findLanguage(btn.getAttribute('data-lang-code')) || findLanguage('en');
        closePicker();
        setGoogleLanguage(selected);
      });
    });
    updateLanguageUI(current);
  }

  function closePicker() {
    var picker = document.querySelector('[data-language-picker]');
    var trigger = picker && picker.querySelector('.language-trigger');
    if (picker) picker.classList.remove('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function initLanguagePicker() {
    var header = document.querySelector('.site-header');
    var picker = document.querySelector('[data-language-picker]');
    if (!picker) return;
    var trigger = picker.querySelector('.language-trigger');
    var current = detectLanguage(header);
    buildLanguageMenu(current);

    /* English is the storefront default. Translation only starts after a manual selection. */
    if (!localStorage.getItem('avenix-language')) {
      localStorage.setItem('avenix-language', 'en');
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = picker.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) {
      if (!picker.contains(e.target)) closePicker();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePicker();
    });
  }

  /* -------------------------------------------------------------
     SPOTIFY MINI DRAWER
     Safe commercial-store version: search opens Spotify and an
     admin-configured public Spotify embed can play inside the drawer.
     We deliberately do not share one Premium account with visitors.
  -------------------------------------------------------------- */
  function normalizeSpotifyEmbed(url) {
    if (!url) return '';
    try {
      var u = new URL(url, location.origin);
      if (u.hostname.indexOf('open.spotify.com') === -1) return url;
      if (u.pathname.indexOf('/embed/') === 0) return u.href;
      var parts = u.pathname.split('/').filter(Boolean);
      if (parts.length >= 2) return 'https://open.spotify.com/embed/' + parts[0] + '/' + parts[1];
    } catch (e) {}
    return url;
  }

  function initSpotify() {
    var drawer = document.querySelector('[data-spotify-drawer]');
    var openBtn = document.querySelector('[data-spotify-toggle]');
    var closeBtn = document.querySelector('[data-spotify-close]');
    var form = document.querySelector('[data-spotify-search]');
    if (!drawer || !openBtn) return;

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      var input = drawer.querySelector('input');
      if (input) setTimeout(function(){ input.focus(); }, 100);
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }

    openBtn.addEventListener('click', function(){
      if (drawer.classList.contains('is-open')) close(); else open();
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (form) form.addEventListener('submit', function(e){
      e.preventDefault();
      var q = form.querySelector('input[name="q"]').value.trim();
      if (!q) return;
      window.open('https://open.spotify.com/search/' + encodeURIComponent(q), '_blank', 'noopener,noreferrer');
    });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });

    var iframe = drawer.querySelector('iframe');
    if (iframe) iframe.src = normalizeSpotifyEmbed(iframe.getAttribute('src'));
  }


  /* -------------------------------------------------------------
     AVENIX SUPPORT CENTER
     Shopify's native contact form sends the request to the store's
     configured contact email. The panel provides a chat-like local
     transcript, but it is not a merchant-side live chat by itself.
  -------------------------------------------------------------- */
  function initSupport() {
    var widget = document.querySelector('[data-support-widget]');
    if (!widget) return;
    var panel = widget.querySelector('[data-support-panel]');
    var open = widget.querySelector('[data-support-open]');
    var close = widget.querySelector('[data-support-close]');
    var form = widget.querySelector('form');

    function show() {
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden','false');
      var input = panel.querySelector('input[type="email"]');
      if (input) setTimeout(function(){ input.focus(); }, 100);
    }
    function hide() {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden','true');
    }
    if (open) open.addEventListener('click', function(){ panel.classList.contains('is-open') ? hide() : show(); });
    if (close) close.addEventListener('click', hide);
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') hide(); });

    if (form) {
      var savedEmail = localStorage.getItem('avenix-support-email');
      var savedMessage = localStorage.getItem('avenix-support-last-message');
      var emailInput = form.querySelector('[name="contact[email]"]');
      if (savedEmail && emailInput && !emailInput.value) emailInput.value = savedEmail;
      if (savedMessage) {
        var existingLog = widget.querySelector('[data-support-log]');
        if (existingLog) {
          var savedBubble = document.createElement('div');
          savedBubble.className = 'support-bubble support-bubble-user';
          savedBubble.textContent = savedMessage;
          existingLog.appendChild(savedBubble);
        }
      }
      form.addEventListener('submit', function(){
        var msg = form.querySelector('[name="contact[body]"]');
        var email = form.querySelector('[name="contact[email]"]');
        if (msg && msg.value.trim()) localStorage.setItem('avenix-support-last-message', msg.value.trim());
        if (email && email.value.trim()) localStorage.setItem('avenix-support-email', email.value.trim());
      });
    }
  }

  /* -------------------------------------------------------------
     ORDER DELIVERY GATE
     - Persists "opened" state locally so refresh does not reset it.
     - If an App Proxy gateway is configured, only the gateway URL is
       sent to the browser; the actual product URL remains server-side.
     - A direct order metafield URL is supported as a fallback, but it
       is NOT a cryptographic anti-leak mechanism.
  -------------------------------------------------------------- */
  function initDeliveryGates() {
    document.querySelectorAll('[data-delivery-gate]').forEach(function(gate){
      var btn = gate.querySelector('[data-receive-order]');
      var link = gate.querySelector('[data-delivery-link]');
      if (!btn || !link) return;
      var orderName = gate.getAttribute('data-order-name') || '';
      var itemId = gate.getAttribute('data-line-item') || '';
      var directUrl = gate.getAttribute('data-delivery-url') || '';
      var gateway = gate.getAttribute('data-delivery-gateway') || '';
      var storageKey = 'avenix-delivery-opened:' + orderName + ':' + itemId;

      function getTarget() {
        if (gateway) {
          var separator = gateway.indexOf('?') === -1 ? '?' : '&';
          return gateway + separator + 'order=' + encodeURIComponent(orderName) + '&item=' + encodeURIComponent(itemId);
        }
        return directUrl;
      }

      function reveal() {
        var target = getTarget();
        if (!target) return;
        localStorage.setItem(storageKey, '1');
        link.href = target;
        link.hidden = false;
        btn.hidden = true;
        var note = gate.querySelector('.delivery-secure-note');
        if (note) note.textContent = 'Acesso liberado. O estado permanece salvo neste dispositivo mesmo após atualizar a página.';
      }

      if (localStorage.getItem(storageKey) === '1') reveal();
      btn.addEventListener('click', function(){
        reveal();
        if (link.href && link.href !== location.href + '#') {
          link.click();
        }
      });
    });

    var hash = location.hash;
    if (hash && hash.indexOf('#order-chat-') === 0) {
      var target = document.querySelector(hash);
      if (target) setTimeout(function(){ target.scrollIntoView({behavior:'smooth',block:'center'}); target.classList.add('chat-highlight'); }, 120);
    }
  }

  /* -------------------------------------------------------------
     MINECRAFT CAPE REQUEST
     Uses Shopify's native contact form so the request is delivered
     to the store contact email configured in Shopify (admin@...).
  -------------------------------------------------------------- */
  function initCapeRequest() {
    document.querySelectorAll('[data-cape-request]').forEach(function(section){
      var form = section.querySelector('form');
      if (!form) return;

      var body = form.querySelector('[data-cape-body]');
      var note = form.querySelector('[name="contact[request_note]"]');
      var email = form.querySelector('[name="contact[email]"]');
      var options = Array.prototype.slice.call(form.querySelectorAll('[data-cape-option]'));
      var countEl = section.querySelector('[data-cape-count]');
      var labelEl = section.querySelector('[data-cape-selection-label]');
      var submit = section.querySelector('[data-cape-submit]');

      function syncBody(){
        var selected = options.filter(function(input){ return input.checked; }).map(function(input){ return input.value; });
        var emailValue = email ? email.value.trim() : '';
        var noteValue = note ? note.value.trim() : '';

        if (countEl) countEl.textContent = String(selected.length);
        if (labelEl) {
          labelEl.textContent = selected.length
            ? selected.join(' • ')
            : 'Select at least one cape below.';
        }
        if (submit) submit.disabled = selected.length === 0;

        var message = [
          'Minecraft Cape Request',
          '',
          'Product: ' + (document.title || 'Minecraft product'),
          'Selected cape(s): ' + (selected.length ? selected.join(', ') : 'None selected'),
          'Customer email: ' + emailValue,
          'Additional note: ' + (noteValue || 'None')
        ].join('\n');

        if (body) body.value = message;
        return selected;
      }

      options.forEach(function(input){ input.addEventListener('change', syncBody); });
      if (note) note.addEventListener('input', syncBody);
      if (email) email.addEventListener('input', syncBody);

      form.addEventListener('submit', function(e){
        var selected = syncBody();
        if (!selected.length) {
          e.preventDefault();
          var error = section.querySelector('[data-cape-selection-error]');
          if (!error) {
            error = document.createElement('p');
            error.setAttribute('data-cape-selection-error','');
            error.className = 'cape-request-error';
            error.textContent = 'Please select at least one cape before sending your request.';
            form.insertBefore(error, form.querySelector('[data-cape-submit]'));
          }
          return false;
        }
      });

      syncBody();
    });
  }

  function initRelatedProducts() {
    document.querySelectorAll('[data-related-products]').forEach(function(section){
      var viewport = section.querySelector('[data-related-viewport]');
      var track = section.querySelector('[data-related-track]');
      var empty = section.querySelector('[data-related-empty]');
      if (!viewport || !track) return;

      var slides = Array.prototype.slice.call(track.querySelectorAll('.related-slide'));
      if (!slides.length) {
        if (empty) empty.hidden = false;
        return;
      }

      var haystack = ((section.getAttribute('data-product-title') || '') + ' ' + (section.getAttribute('data-product-description-text') || '')).toLowerCase();
      var auto = /minecraft|account|cape|skin|cosmetic|rank|hypixel|gaming account/.test(haystack);
      section.classList.toggle('related-auto-scroll', auto);

      var controls = section.querySelector('.related-controls');
      if (controls) {
        controls.innerHTML = '';
        slides.forEach(function(slide, index){
          var dot = document.createElement('span');
          dot.setAttribute('data-related-dot', index);
          controls.appendChild(dot);
        });
      }

      function updateDots(){
        if (!controls) return;
        var max = Math.max(1, viewport.scrollWidth - viewport.clientWidth);
        var ratio = viewport.scrollLeft / max;
        var index = Math.min(slides.length - 1, Math.round(ratio * (slides.length - 1)));
        controls.querySelectorAll('[data-related-dot]').forEach(function(dot, i){
          dot.classList.toggle('is-active', i === index);
        });
      }

      viewport.addEventListener('scroll', updateDots, {passive:true});
      updateDots();

      if (!auto || slides.length < 2) return;

      var timer = null;
      var paused = false;

      function step(){
        if (paused) return;
        var first = track.querySelector('.related-slide');
        if (!first) return;
        var gap = 18;
        var distance = first.getBoundingClientRect().width + gap;
        var max = viewport.scrollWidth - viewport.clientWidth;
        if (max <= 2) return;
        if (viewport.scrollLeft >= max - 8) {
          viewport.scrollTo({left:0, behavior:'smooth'});
        } else {
          viewport.scrollBy({left:distance, behavior:'smooth'});
        }
      }
      function start(){ if (!timer) timer = setInterval(step, 3200); }
      function stop(){ if (timer) { clearInterval(timer); timer=null; } }

      viewport.addEventListener('mouseenter', function(){ paused=true; });
      viewport.addEventListener('mouseleave', function(){ paused=false; });
      viewport.addEventListener('touchstart', function(){ paused=true; }, {passive:true});
      viewport.addEventListener('touchend', function(){ paused=false; });
      document.addEventListener('visibilitychange', function(){
        if (document.hidden) stop(); else start();
      });
      start();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var toggle = document.querySelector('[data-mobile-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        nav.classList.toggle('mobile-open');
        toggle.setAttribute('aria-expanded', nav.classList.contains('mobile-open'));
      });
    }
    document.querySelectorAll('[data-auto-submit]').forEach(function (el) {
      el.addEventListener('change', function(){ if (el.form) el.form.submit(); });
    });
    initLanguagePicker();
    initSpotify();
    initSupport();
    initDeliveryGates();
    initCapeRequest();
    initRelatedProducts();
  });
})();

/* Avenix account dropdown */
(function(){
  function initAccountMenu(){
    var menus=document.querySelectorAll('[data-account-menu]');
    menus.forEach(function(menu){
      var toggle=menu.querySelector('[data-account-toggle]');
      var dropdown=menu.querySelector('[data-account-dropdown]');
      if(!toggle||!dropdown||menu.dataset.ready==='1') return;
      menu.dataset.ready='1';
      toggle.addEventListener('click',function(e){
        e.stopPropagation();
        var open=!dropdown.hasAttribute('hidden');
        document.querySelectorAll('[data-account-dropdown]').forEach(function(d){d.hidden=true;});
        document.querySelectorAll('[data-account-toggle]').forEach(function(t){t.setAttribute('aria-expanded','false');});
        if(!open){dropdown.hidden=false;toggle.setAttribute('aria-expanded','true');}
      });
      dropdown.addEventListener('click',function(e){e.stopPropagation();});
    });
    document.addEventListener('click',function(){
      document.querySelectorAll('[data-account-dropdown]').forEach(function(d){d.hidden=true;});
      document.querySelectorAll('[data-account-toggle]').forEach(function(t){t.setAttribute('aria-expanded','false');});
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initAccountMenu); else initAccountMenu();
})();
